var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  "dismiss": "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"
};
export { $d11f19852b941573$exports as default };